import React, { Dispatch } from 'react';

export const positivos = [
  { id: 1, valor: 'Conflitos resolvidos' },
  { id: 2, valor: 'Expectativas alinhadas' },
  { id: 3, valor: 'Resultados e entregas bons' },
  { id: 4, valor: 'Progresso em metas e projetos' },
  { id: 5, valor: 'Orgulho do meu time' },
  { id: 6, valor: 'Orgulho da empresa' },
  { id: 7, valor: 'Alta produtividade' },
  { id: 8, valor: 'Alta motivação' },
  { id: 9, valor: 'Apoio da equipe' },
  { id: 10, valor: 'Apoio de líder' },
  { id: 11, valor: 'Animação com desafios' },
  { id: 12, valor: 'Propósito claro' },
  { id: 13, valor: 'Bons feedbacks recebidos' },
  { id: 14, valor: 'Reconhecimento recebido' },
  { id: 15, valor: 'Satisfação na vida pessoal' },
  { id: 16, valor: 'Clareza nas prioridades' }
];

export const negativos = [
  { id: 101, valor: 'Resultados e entregas ruins' },
  { id: 102, valor: 'Problemas pessoais' },
  { id: 103, valor: 'Falta de reconhecimento' },
  { id: 104, valor: 'Carga de trabalho excessiva' },
  { id: 105, valor: 'Dificuldades com a equipe' },
  { id: 106, valor: 'Falta de clareza nas prioridades' },
  { id: 107, valor: 'Expectativas desalinhadas' },
  { id: 108, valor: 'Falta de propósito' },
  { id: 109, valor: 'Demandas inesperadas' },
  { id: 110, valor: 'Produtividade ruim' },
  { id: 111, valor: 'Pouco progresso em metas e projetos' },
  { id: 112, valor: 'Conflitos não resolvidos' },
  { id: 113, valor: 'Falta de suporte do líder' },
  { id: 114, valor: 'Pressão excessiva' }
];

export const Chip = ({
  label,
  selected,
  onClick,
}: {
  label: string;
  selected: boolean;
  onClick: () => void;
}) => (
  <span
    onClick={onClick}
    style={{
      padding: '8px 12px',
      margin: '6px',
      borderRadius: '999px',
      backgroundColor: selected ? '#0d6efd' : '#e0e6f0',
      color: selected ? '#fff' : '#2c3e50',
      cursor: 'pointer',
      fontSize: '14px',
      display: 'inline-block',
    }}
  >
    {label}
  </span>
);

interface FeedbackChipsProps {
  selectedPositivos: number[]
  selectedNegativos: number[]
  setSelectedPositivos?: Dispatch<React.SetStateAction<number[]>>
  setSelectedNegativos?: Dispatch<React.SetStateAction<number[]>>
  editing?: boolean
}

export default function FeedbackChips({
  selectedNegativos,
  selectedPositivos,
  setSelectedNegativos,
  setSelectedPositivos,
  editing = true
}: FeedbackChipsProps) {
  const toggle = (id: number, type: 'positivo' | 'negativo') => {
    if (editing && setSelectedNegativos && setSelectedPositivos) {
      const set = type === 'positivo' ? setSelectedPositivos : setSelectedNegativos;
      const selected = type === 'positivo' ? selectedPositivos : selectedNegativos;
  
      set(
        selected.includes(id)
          ? selected.filter((item) => item !== id)
          : [...selected, id]
      );
    }
  };

  return (
    <div>
      <h5>O que foi bom?</h5>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {positivos.map(({ id, valor }) => (
          <Chip
            key={id}
            label={valor}
            selected={selectedPositivos.includes(id)}
            onClick={() => toggle(id, 'positivo')}
          />
        ))}
      </div>

      <h5 style={{ marginTop: '2rem' }}>O que não foi bom?</h5>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {negativos.map(({ id, valor }) => (
          <Chip
            key={id}
            label={valor}
            selected={selectedNegativos.includes(id)}
            onClick={() => toggle(id, 'negativo')}
          />
        ))}
      </div>
    </div>
  );
}